import { useState } from 'react';
import type { MediaAsset } from '@agency/contracts';
import { Drawer, EmptyState, Skeleton, TextField } from '@agency/ui';
import { MediaGrid, useMediaList, useUpload } from '../media/media-page.tsx';
import { QueryError } from '../../lib/query-state.tsx';
import { Button } from '@agency/ui';
import { useAuth } from '../../lib/auth.tsx';

/** Chooses an image from the library, or uploads a new one. Archived images are not offered. */
export function MediaPicker({ open, onClose, onPick }: { open: boolean; onClose: () => void; onPick: (a: MediaAsset) => void }) {
  const { can } = useAuth();
  const [q, setQ] = useState('');
  const list = useMediaList({ q }, open);
  const up = useUpload((a) => { onPick(a); onClose(); });
  return (
    <Drawer open={open} onClose={onClose} title="Choose an image" width={640}>
      <div style={{ display: 'grid', gap: 12 }}>
        <TextField label="Search" type="search" value={q} onChange={(e) => setQ(e.target.value)} data-autofocus />
        {can('content.edit') ? (
          <label className="ag-btn" style={{ justifySelf: 'start' }}>
            {up.busy ? 'Uploading…' : 'Upload a new image'}
            <input type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="ag-visually-hidden" onChange={(e) => { const f = e.target.files?.[0]; if (f) void up.run([f]); e.target.value = ''; }} />
          </label>
        ) : null}
        {up.errors.length ? <p role="alert" className="ag-error">{up.errors.join(' ')}</p> : null}
        {!open ? null : list.isLoading || !list.data && !list.isError ? <div role="status"><span className="ag-visually-hidden">Loading images…</span><Skeleton height={140} /></div>
          : list.isError ? <QueryError error={list.error} onRetry={() => void list.refetch()} />
          : list.data!.length === 0 ? <EmptyState title="No images" icon="file">Upload one to get started.</EmptyState>
          : <MediaGrid items={list.data!} onPick={(a) => { onPick(a); onClose(); }} />}
        <div><Button onClick={onClose}>Cancel</Button></div>
      </div>
    </Drawer>
  );
}
